define("SuiteDB.SDBServiceHardwareItems.SDBServiceHardwareItems", [
  "SuiteDB.SDBServiceHardwareItems.SDBServiceHardwareItems.View",
  "SuiteDB.SDBServiceHardwareItems.SDBServiceItemsSummary.View",
  "SuiteDB.SDBServiceHardwareItems.SDBServiceHardwareItems.Model",
  "LiveOrder.Model",
  "Cart.Confirmation.View",
  "SuiteDB.SDBServiceHardwareItems.SDBServiceHardwareItemsPDP.View",
  "suitedb_cart_confirmation_modal_override.tpl",
  "SDB.SelectWheelsOrTires.SS2Model",
  "SDB.SDBLocations.Model",
  "Cart.AddToCart.Button.View",
  "SDB.Modal.Content.View",
  "SDB.SelectYourVehicle.View",
  "Utils",
  "Profile.Model",
  "ExternalVendor.Inventory.SS2Model",
], function (
  SDBServiceHardwareItemsView,
  SDBServiceItemsSummaryView,
  SDBServiceHardwareItemsModel,
  LiveOrderModel,
  CartConfirmation,
  SDBServiceHardwareItemsViewPDP,
  suitedb_cart_confirmation_modal_override_tpl,
  SDBSelectWheelsOrTiresSS2Model,
  SDBLocationsModel,
  AddToCartButtonView,
  SDBModalContentView,
  SDBSelectYourVehicleView,
  Utils,
  ProfileModel,
  ExternalVendorInventorySS2Model
) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      var model = SDBServiceHardwareItemsModel.getInstance();
      var Environment = container.getComponent("Environment");
      var pdp = container.getComponent("PDP");
      var LiveOrder = LiveOrderModel.getInstance();
      var Cart = container.getComponent("Cart");
      var Profile = ProfileModel.getInstance();
      //other models
      model.wheelsTiresModel = SDBSelectWheelsOrTiresSS2Model.getInstance();
      model.locations = SDBLocationsModel.getInstance();
      model.externalVendor = ExternalVendorInventorySS2Model.getInstance();
      //service config
      model.servicesConfigOnline = Environment.getConfig(
        "SDBServiceItemsOnline"
      );
      model.servicesConfigInStore = Environment.getConfig(
        "SDBServiceItemsInStore"
      );
      //hardware config
      model.hardwareConfigOnline = Environment.getConfig(
        "SDBHardwareItemsOnline"
      );
      model.hardwareConfigInStore = Environment.getConfig(
        "SDBHardwareItemsInStore"
      );
      //model attributes
      model.liveOrder = LiveOrder;
      model.cart = Cart;
      model.state = "AB";
      model.profile = Profile;

      //get items from the cart
      model.set("itemMapper", {});
      model.set("items", []);
      LiveOrder.on("change:lines", function (liveOrder, lines) {
        model.itemIds = _.map(lines, function (line) {
          return line.item.internalid;
        });
        if (Utils.isInShopping() || Utils.isInCheckout()) {
          var items = [];
          var itemMapper = {};
          _.each(lines, function (line) {
            var lineItem = line.item;
            lineItem.quantity = line.quantity;
            items.push(lineItem);
            itemMapper[lineItem.internalid] = lineItem;
          });
          model.set("itemMapper", itemMapper);
          model.set("items", items, { trigger: true });
        }
      });
      //update suggestions
      function updateSuggestions(items) {
        if (!model.fetched) return;
        if (!(Utils.isInShopping() || Utils.isInCheckout())) return;
        model.suggestions = model.getRecommendations(items);
        model.removeInvalidServices();
        if (model.removingItems) {
          model.suggestions = [];
          return;
        }
        model.suggestions = model.groupSuggestions(model.suggestions);
        model.suggestions = model.removeAddedRecommendations(model.suggestions);
        if (Utils.isInCheckout()) model.setCustomFields();
        model.updateState();
        model.manageSummaryServices();
        model.updateOrderTotal();
        if (model.cartView) model.cartView.render();
        if (model.PDPView) model.PDPView.render();
        if (model.summaryView) {
          model.summaryView.render();
        }
      }
      model.on("change:items", function (model, items) {
        updateSuggestions(items);
      });
      model.locations.on({
        "change:shoppingExperience": function changeShoppingExperience() {
          if (model.locations.getShoppingExperience() != "online") return;
          updateSuggestions(model.get("items"));
        },
        "change:location": function changeLocation() {
          if (model.locations.getShoppingExperience() != "instore") return;
          updateSuggestions(model.get("items"));
        },
      });
      model.on("change:vehicleChanged", function () {
        updateSuggestions(model.get("items"));
      });

      //get all configured service ids
      var allServices = []
        .concat(model.servicesConfigOnline.ByItem)
        .concat(model.servicesConfigOnline.FieldComparison)
        .concat(model.servicesConfigInStore.ByItem)
        .concat(model.servicesConfigInStore.FieldComparison);
      var serviceItemIds = _.pluck(allServices, "serviceItem");
      serviceItemIds = _.uniq(serviceItemIds);

      //get all configured hardware ids
      var allHardwareItems = []
        .concat(model.hardwareConfigOnline.GeneralApplication)
        .concat(model.hardwareConfigOnline.VehicleAndItemComparison)
        .concat(model.hardwareConfigInStore.GeneralApplication)
        .concat(model.hardwareConfigInStore.VehicleAndItemComparison);
      var hardwareItemIds = _.pluck(allHardwareItems, "hardwareItem");
      hardwareItemIds = _.uniq(hardwareItemIds);

      var serviceItems;
      model
        .fetch({
          data: {
            serviceItems: JSON.stringify(serviceItemIds),
            requestType: "serviceItems",
          },
          async: true,
        })
        .done(function (res) {
          if (!res.error) {
            //save service item info
            var serviceItems = res.serviceItems;
            _.each(serviceItems, function (element) {
              if (!element.serviceItem.image) return;
              element.serviceItem.image =
                "//" +
                Backbone.history.location.host +
                element.serviceItem.image;
            });
            model.serviceItems = serviceItems;
            model.set("fetchedServices", true);
          }
        });
      var hardwareItems;
      model
        .fetch({
          data: {
            hardwareItems: JSON.stringify(hardwareItemIds),
            requestType: "hardwareItems",
          },
          async: true,
        })
        .done(function (res) {
          if (!res.error) {
            //save hardware item info
            model.hardwareItems = res;
            model.hardwareMapper = _.reduce(
              model.hardwareItems,
              function (acc, hardware) {
                acc[hardware.id] = hardware;
                return acc;
              },
              {}
            );
            model.set("fetchedHardware", true);
          }
        });

      //render related views after fetching
      model.on("change:fetchedServices change:fetchedHardware", function () {
        if (model.serviceItems && model.hardwareItems) {
          model.fetched = true;
          var items = model.get("items");
          if (!items) return;
          updateSuggestions(items);
        }
      });

      //update selected vehicle
      model.updateVehicle();
      model.wheelsTiresModel.on("change:vehicleConfig", function () {
        model.updateVehicle();
        var change = !model.get("vehicleChanged");
        model.set("vehicleChanged", change);
      });

      /** @type {LayoutComponent} */
      var layout = container.getComponent("Layout");
      var self = this;
      self.layout = layout;
      self.container = container;
      if (layout) {
        layout.addChildView("ServiceHardwareItems", function () {
          return new SDBServiceHardwareItemsView({ container: container });
        });
        layout.addChildView("ServiceItems", function () {
          return new SDBServiceItemsSummaryView({ container: container });
        });
      }

      if (pdp) {
        _.extend(CartConfirmation.prototype, {
          template: suitedb_cart_confirmation_modal_override_tpl,
          childViews: _.extend(CartConfirmation.prototype.childViews, {
            ServiceHardwareItemsPDP: function ServiceHardwareItemsPDP() {
              return new SDBServiceHardwareItemsViewPDP({
                container: container,
                serviceItems: serviceItems,
                hardwareItems: hardwareItems,
              });
            },
          }),
          getContext: _.wrap(
            CartConfirmation.prototype.getContext,
            function (fn) {
              var ctx = fn.apply(
                this,
                Array.prototype.slice.call(arguments, 1)
              );
              model.set(
                "PDPItemInfo",
                JSON.stringify({
                  internalid: ctx.model.attributes.item.id,
                  extras: ctx.model.attributes.item.attributes,
                  quantity: ctx.model.attributes.quantity,
                  displayname: ctx.model.attributes.item.attributes.displayname,
                })
              );
              var item = ctx.model.get("item");
              var modelName = item.get("custitemrs_model");
              var brand = item.get("custitemrs_brand");
              var displayname = item.get("displayname");
              if (modelName && brand) {
                ctx.alteredName = true;
                ctx.modelName = modelName;
                ctx.brand = brand;
              }

              displayname
                ? (ctx.displayname = displayname)
                : (ctx.displayname = item.get("displayname"));
              return ctx;
            }
          ),
        });
        AddToCartButtonView.prototype.addToCart = _.wrap(
          AddToCartButtonView.prototype.addToCart,
          function (fn) {
            var event = _.toArray(arguments).slice(1)[0];
            var isNotNow = localStorage.getItem("isNotNow");
            if (model.locations.getCookie("vehicleConfig").length || isNotNow) {
              localStorage.removeItem("isNotNow");
              fn.apply(this, _.toArray(arguments).slice(1));
            } else {
              event.preventDefault();
              var modalView = new SDBModalContentView({
                parentView: this.parentView,
                contentView: SDBSelectYourVehicleView,
                container: self.container,
                pageHeader: "Select Your Vehicle To Get Suggestions",
                showContinue: true,
                itemQuantity: this.model.get("quantity"),
                itemID: this.model.get("item").get("internalid"),
              });
              self.layout.showContent(modalView, { showInModal: true });
            }
          }
        );
      }

      if (Utils.isInCheckout()) {
        //keep total updated in checkout
        var OrderWizardModuleCartSummary = importModule(
          "OrderWizard.Module.CartSummary"
        );
        OrderWizardModuleCartSummary.prototype.getContext = _.wrap(
          OrderWizardModuleCartSummary.prototype.getContext,
          function (fn) {
            var summary = this.model.get("summary");
            var total = model.updateOrderTotal();
            summary.total_formatted = Utils.formatCurrency(total);
            return fn.apply(this, Array.prototype.slice.call(arguments, 1));
          }
        );
      }

      if (Utils.isInShopping()) {
        //prevent services from appearing on the quick add
        var ItemsSearcherView = importModule("ItemsSearcher.View");
        ItemsSearcherView.prototype.getItemIds = _.wrap(
          ItemsSearcherView.prototype.getItemIds,
          function (fn) {
            if (this.options.componentName !== "quickaddSearch")
              return fn.apply(this, Array.prototype.slice.call(arguments, 1));
            var self = this;
            var itemsToRemove = [];
            _.each(this.collection.models, function (itemModel) {
              var itemType = itemModel
                .get("item")
                .get("itemtype")
                .toLowerCase();
              // if item have hide Price on it then remove
              if (itemModel.get("item").get("custitem_sdb_item_hide_price"))
                itemsToRemove.push(itemModel);
              // if item have hide Price on it then remove

              if (
                _.contains(
                  model.externalVendor.recordTypesNotPurchasable,
                  itemType
                )
              )
                itemsToRemove.push(itemModel);
            });
            _.each(itemsToRemove, function (model) {
              self.collection.remove(model);
            });
            return fn.apply(this, Array.prototype.slice.call(arguments, 1));
          }
        );
      }

      function importModule(module) {
        var moduleObject = {};
        var moduleName = module.replace(/\./g, "");
        moduleObject[moduleName] = require(module);
        return moduleObject[moduleName].moduleName
          ? moduleObject[moduleName].moduleName
          : moduleObject[moduleName];
      }
    },
  };
});
